












import { Component, Vue } from 'vue-property-decorator';
@Component
export default class Login extends Vue {
    clientId = '240290736253-k6l06isjheuei15jr2a3hv8gm7en2259.apps.googleusercontent.com';

    private onSignIn(googleUser: any) {
        const profile = googleUser.getBasicProfile();
        console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
        console.log('Name: ' + profile.getName());
        console.log('Image URL: ' + profile.getImageUrl());
        console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.
    }

    handleCredentialResponse(profile: any) {
        console.log(profile);
    }

    mounted() {
        window.onload = function() {
            // eslint-disable-next-line no-undef
            // google.accounts.id.initialize({
            //     // eslint-disable-next-line @typescript-eslint/camelcase
            //     client_id: '240290736253-k6l06isjheuei15jr2a3hv8gm7en2259.apps.googleusercontent.com',
            //     callback: function(profile) {
            //         console.log(profile);
            //     },
            // });
            // // eslint-disable-next-line no-undef
            // google.accounts.id.prompt();
        };

        // window.gapi.load('auth2', () => {
        //     // eslint-disable-next-line @typescript-eslint/camelcase
        //     const auth2 = window.gapi.auth2.init({ client_id: this.clientId });
        //     auth2.attachClickHandler(
        //         'signinBtn',
        //         {},
        //         googleUser => {
        //             this.$emit('success', googleUser);
        //         },
        //         error => {
        //             this.$emit('error', error);
        //             this.$emit('failure', error); // an alias
        //         },
        //     );
        // });
    }
    methods() {
        function err(msg: string) {
            typeof console !== 'undefined' && console.error(`[g-signin-button] ${msg}`);
        }
    }
}
